export const EVENTS_REINIT_STATE = 'EVENTS:REINIT_STATE';
export const EVENTS_SET_JUST_PUBLISHED_FLAG = 'EVENTS:SET_JUST_PUBLISHED_FLAG';
export const EVENTS_CLEAR_JUST_PUBLISHED_FLAG = 'EVENTS:CLEAR_JUST_PUBLISHED_FLAG';
export const EVENTS_SAVE_REQUEST = 'EVENTS:SAVE_REQUEST';
export const EVENTS_SAVE_SUCCESS = 'EVENTS:SAVE_SUCCESS';
export const EVENTS_SAVE_FAILURE = 'EVENTS:SAVE_FAILURE';
export const EVENTS_INVITE_PLAYERS_REQUEST = 'EVENTS:INVITE_PLAYERS_REQUEST';
export const EVENTS_INVITE_PLAYERS_SUCCESS = 'EVENTS:INVITE_PLAYERS_SUCCESS';
export const EVENTS_INVITE_PLAYERS_FAILURE = 'EVENTS:INVITE_PLAYERS_FAILURE';
export const EVENTS_UPDATE_REQUEST = 'EVENTS:UPDATE_REQUEST';
export const EVENTS_UPDATE_SUCCESS = 'EVENTS:UPDATE_SUCCESS';
export const EVENTS_UPDATE_FAILURE = 'EVENTS:UPDATE_FAILURE';
export const EVENTS_DELETE_REQUEST = 'EVENTS:DELETE_REQUEST';
export const EVENTS_DELETE_SUCCESS = 'EVENTS:DELETE_SUCCESS';
export const EVENTS_DELETE_FAILURE = 'EVENTS:DELETE_FAILURE';
export const EVENTS_DRAWS_FETCH_REQUEST = 'EVENTS:DRAWS_FETCH_REQUEST';
export const EVENTS_DRAWS_FETCH_SUCCESS = 'EVENTS:DRAWS_FETCH_SUCCESS';
export const EVENTS_DRAWS_FETCH_FAILURE = 'EVENTS:DRAWS_FETCH_FAILURE';
export const EVENTS_LOCATIONS_FETCH_REQUEST = 'EVENTS:LOCATIONS_FETCH_REQUEST';
export const EVENTS_LOCATIONS_FETCH_SUCCESS = 'EVENTS:LOCATIONS_FETCH_SUCCESS';
export const EVENTS_LOCATIONS_FETCH_FAILURE = 'EVENTS:LOCATIONS_FETCH_FAILURE';
export const EVENTS_LOCATIONS_EXCLUDE_REQUEST = 'EVENTS:LOCATIONS_EXCLUDE_REQUEST';
export const EVENTS_LOCATIONS_EXCLUDE_SUCCESS = 'EVENTS:LOCATIONS_EXCLUDE_SUCCESS';
export const EVENTS_LOCATIONS_EXCLUDE_FAILURE = 'EVENTS:LOCATIONS_EXCLUDE_FAILURE';
export const EVENTS_OFFICIALS_FETCH_REQUEST = 'EVENTS:OFFICIALS_FETCH_REQUEST';
export const EVENTS_OFFICIALS_FETCH_SUCCESS = 'EVENTS:OFFICIALS_FETCH_SUCCESS';
export const EVENTS_OFFICIALS_FETCH_FAILURE = 'EVENTS:OFFICIALS_FETCH_FAILURE';
export const EVENTS_OFFICIALS_UPDATE_REQUEST = 'EVENTS:OFFICIALS_UPDATE_REQUEST';
export const EVENTS_OFFICIALS_UPDATE_SUCCESS = 'EVENTS:OFFICIALS_UPDATE_SUCCESS';
export const EVENTS_OFFICIALS_UPDATE_FAILURE = 'EVENTS:OFFICIALS_UPDATE_FAILURE';
export const EVENTS_ACCEPTANCE_FETCH_REQUEST = 'EVENTS:ACCEPTANCE_FETCH_REQUEST';
export const EVENTS_ACCEPTANCE_FETCH_SUCCESS = 'EVENTS:ACCEPTANCE_FETCH_SUCCESS';
export const EVENTS_ACCEPTANCE_FETCH_FAILURE = 'EVENTS:ACCEPTANCE_FETCH_FAILURE';
export const EVENTS_FETCH_REQUEST = 'EVENTS:FETCH_REQUEST';
export const EVENTS_FETCH_SUCCESS = 'EVENTS:FETCH_SUCCESS';
export const EVENTS_FETCH_FAILURE = 'EVENTS:FETCH_FAILURE';
export const EVENTS_DRAWS_VIEW_FETCH_REQUEST = 'EVENTS:DRAWS_VIEW_FETCH_REQUEST';
export const EVENTS_DRAWS_VIEW_FETCH_SUCCESS = 'EVENTS:DRAWS_VIEW_FETCH_SUCCESS';
export const EVENTS_DRAWS_VIEW_FETCH_FAILURE = 'EVENTS:DRAWS_VIEW_FETCH_FAILURE';
export const EVENTS_REG_SUCCESS = 'EVENTS:REG_SUCCESS';
export const EVENTS_DRAWS_INIT_REQUEST = 'EVENTS:DRAWS_INIT_REQUEST';
export const EVENTS_DRAWS_INIT_SUCCESS = 'EVENTS:DRAWS_INIT_SUCCESS';
export const EVENTS_DRAWS_INIT_FAILURE = 'EVENTS:DRAWS_INIT_FAILURE';
export const EVENTS_DRAWS_DELETE_REQUEST = 'EVENTS:DRAWS_DELETE_REQUEST';
export const EVENTS_DRAWS_DELETE_SUCCESS = 'EVENTS:DRAWS_DELETE_SUCCESS';
export const EVENTS_DRAWS_DELETE_FAILURE = 'EVENTS:DRAWS_DELETE_FAILURE';
export const EVENTS_RESET_REQUEST = 'EVENTS:RESET_REQUEST';
export const EVENTS_RESET_SUCCESS = 'EVENTS:RESET_SUCCESS';
export const EVENTS_RESET_FAILURE = 'EVENTS:RESET_FAILURE';
export const EVENTS_DRAWS_AUTOFILL_REQUEST = 'EVENTS:DRAWS_AUTOFILL_REQUEST';
export const EVENTS_DRAWS_AUTOFILL_SUCCESS = 'EVENTS:DRAWS_AUTOFILL_SUCCESS';
export const EVENTS_DRAWS_AUTOFILL_FAILURE = 'EVENTS:DRAWS_AUTOFILL_FAILURE';
export const EVENTS_DRAWS_PUBLISH_REQUEST = 'EVENTS:DRAWS_PUBLISH_REQUEST';
export const EVENTS_DRAWS_PUBLISH_SUCCESS = 'EVENTS:DRAWS_PUBLISH_SUCCESS';
export const EVENTS_DRAWS_PUBLISH_FAILURE = 'EVENTS:DRAWS_PUBLISH_FAILURE';
export const EVENTS_DRAWS_SAVE_REQUEST = 'EVENTS:DRAWS_SAVE_REQUEST';
export const EVENTS_DRAWS_SAVE_SUCCESS = 'EVENTS:DRAWS_SAVE_SUCCESS';
export const EVENTS_DRAWS_SAVE_FAILURE = 'EVENTS:DRAWS_SAVE_FAILURE';
export const EVENTS_POST_SCORE_REQUEST = 'EVENTS:POST_SCORE_REQUEST';
export const EVENTS_POST_SCORE_SUCCESS = 'EVENTS:POST_SCORE_SUCCESS';
export const EVENTS_POST_SCORE_FAILURE = 'EVENTS:POST_SCORE_FAILURE';
export const EVENTS_SEND_INVITATION_TO_GROUP = 'EVENTS:EVENTS_SEND_INVITATION_TO_GROUP';
export const EVENTS_SEND_INVITATION_TO_GROUP_SUCCESS = 'EVENTS:EVENTS_SEND_INVITATION_TO_GROUP_SUCCESS';
export const EVENTS_SEND_INVITATION_TO_GROUP_FAILURE = 'EVENTS:EVENTS_SEND_INVITATION_TO_GROUP_FAILURE';
export const EVENTS_SEND_MESSAGE_TO_PLAYERS = 'EVENTS:SEND_MESSAGE_TO_PLAYERS';
export const EVENTS_SEND_MESSAGE_TO_PLAYERS_SUCCESS = 'EVENTS:SEND_MESSAGE_TO_PLAYERS_SUCCESS';
export const EVENTS_SEND_MESSAGE_TO_PLAYERS_FAILURE = 'EVENTS:SEND_MESSAGE_TO_PLAYERS_FAILURE';
export const EVENTS_CLEAR_SCORE_REQUEST = 'EVENTS:CLEAR_SCORE_REQUEST';
export const EVENTS_CLEAR_SCORE_SUCCESS = 'EVENTS:CLEAR_SCORE_SUCCESS';
export const EVENTS_CLEAR_SCORE_FAILURE = 'EVENTS:CLEAR_SCORE_FAILURE';
export const EVENTS_CONTACT_MEMBERS_REQUEST = 'EVENTS:CONTACT_MEMBERS_REQUEST';
export const EVENTS_CONTACT_MEMBERS_SUCCESS = 'EVENTS:CONTACT_MEMBERS_SUCCESS';
export const EVENTS_CONTACT_MEMBERS_FAILURE = 'EVENTS:CONTACT_MEMBERS_FAILURE';
export const EVENTS_UPLOAD_ATTACHMENT_REQUEST = 'EVENTS:UPLOAD_ATTACHMENT_REQUEST';
export const EVENTS_UPLOAD_ATTACHMENT_SUCCESS = 'EVENTS:UPLOAD_ATTACHMENT_SUCCESS';
export const EVENTS_UPLOAD_ATTACHMENT_FAILURE = 'EVENTS:UPLOAD_ATTACHMENT_FAILURE';
export const EVENTS_FETCH_ATTACHMENT_REQUEST = 'EVENTS:FETCH_ATTACHMENT_REQUEST';
export const EVENTS_FETCH_ATTACHMENT_SUCCESS = 'EVENTS:FETCH_ATTACHMENT_SUCCESS';
export const EVENTS_FETCH_ATTACHMENT_FAILURE = 'EVENTS:FETCH_ATTACHMENT_FAILURE';
export const EVENTS_REGPAYMENTS_FETCH_REQUEST = 'EVENTS:REGPAYMENTS_FETCH_REQUEST';
export const EVENTS_REGPAYMENTS_FETCH_SUCCESS = 'EVENTS:REGPAYMENTS_FETCH_SUCCESS';
export const EVENTS_REGPAYMENTS_FETCH_FAILURE = 'EVENTS:REGPAYMENTS_FETCH_FAILURE';
export const EVENTS_SET_OVERVIEW_TAB_STATE = 'EVENTS:SET_OVERVIEW_TAB_STATE';
export const EVENTS_SET_DRAWS_TAB_STATE = 'EVENTS:SET_DRAWS_TAB_STATE';
export const EVENTS_SET_PLAYERS_TAB_STATE = 'EVENTS:SET_PLAYERS_TAB_STATE';
export const EVENTS_CLONE_REQUEST = 'EVENTS:CLONE_REQUEST';
export const EVENTS_CLONE_SUCCESS = 'EVENTS:CLONE_SUCCESS';
export const EVENTS_CLONE_FAILURE = 'EVENTS:CLONE_FAILURE';
export const EVENTS_HIDE_DELETE_FAILED_POPUP = 'EVENTS:HIDE_DELETE_FAILED_POPUP';
export const EVENTS_REG_ADD_TEAMMATE = 'EVENTS:REG_ADD_TEAMMATE';
export const EVENTS_UPDATE_DRAWS = 'EVENTS:UPDATE_DRAWS';

export const EVENTS_GET_MATCH_OFFICIALS_REQUEST = 'EVENTS_GET_MATCH_OFFICIALS_REQUEST';
export const EVENTS_GET_MATCH_OFFICIALS_SUCCESS = 'EVENTS_GET_MATCH_OFFICIALS_SUCCESS';
export const EVENTS_GET_MATCH_OFFICIALS_FAILURE = 'EVENTS_GET_MATCH_OFFICIALS_FAILURE';
export const EVENTS_ADD_MATCH_OFFICIAL_REQUEST = 'EVENTS_ADD_MATCH_OFFICIAL_REQUEST';
export const EVENTS_ADD_MATCH_OFFICIAL_SUCCESS = 'EVENTS_ADD_MATCH_OFFICIAL_SUCCESS';
export const EVENTS_ADD_MATCH_OFFICIAL_FAILURE = 'EVENTS_ADD_MATCH_OFFICIAL_FAILURE';
export const EVENTS_DELETE_MATCH_OFFICIAL_REQUEST = 'EVENTS_DELETE_MATCH_OFFICIAL_REQUEST';
export const EVENTS_DELETE_MATCH_OFFICIAL_SUCCESS = 'EVENTS_DELETE_MATCH_OFFICIAL_SUCCESS';
export const EVENTS_DELETE_MATCH_OFFICIAL_FAILURE = 'EVENTS_DELETE_MATCH_OFFICIAL_FAILURE';
export const EVENTS_UPDATE_SCHEDULE_TYPE = 'EVENTS_UPDATE_SCHEDULE_TYPE';
export const EVENTS_UPDATE_SCHEDULE_TYPE_REQUEST = 'EVENTS_UPDATE_SCHEDULE_TYPE_REQUEST';
export const EVENTS_UPDATE_SCHEDULE_TYPE_SUCCESS = 'EVENTS_UPDATE_SCHEDULE_TYPE_SUCCESS';
export const EVENTS_UPDATE_SCHEDULE_TYPE_FAILURE = 'EVENTS_UPDATE_SCHEDULE_TYPE_FAILURE';
export const EVENTS_FETCH_MATCH_SHEET_SUCCESS = 'EVENTS_FETCH_MATCH_SHEET_SUCCESS';
export const EVENTS_UPDATE_MATCH_SHEET_REQUEST = 'EVENTS_UPDATE_MATCH_SHEET_REQUEST';
export const EVENTS_UPDATE_MATCH_SHEET_SUCCESS = 'EVENTS_UPDATE_MATCH_SHEET_SUCCESS';
export const EVENTS_DELETE_MATCH_SHEET_SUCCESS = 'EVENTS_DELETE_MATCH_SHEET_SUCCESS';
export const EVENTS_UPDATE_MATCH_SHEET_FAILURE = 'EVENTS_UPDATE_MATCH_SHEET_FAILURE';
export const EVENTS_UPDATE_MATCH_SHEET_ROUND_REQUEST = 'EVENTS_UPDATE_MATCH_SHEET_ROUND_REQUEST';
export const EVENTS_UPDATE_MATCH_SHEET_ROUND_SUCCESS = 'EVENTS_UPDATE_MATCH_SHEET_ROUND_SUCCESS';
export const EVENTS_UPDATE_MATCH_SHEET_ROUND_FAILURE = 'EVENTS_UPDATE_MATCH_SHEET_ROUND_FAILURE';
export const EVENTS_GET_DRAW_OFFICIALS_REQUEST = 'EVENTS_GET_DRAW_OFFICIALS_REQUEST';
export const EVENTS_GET_DRAW_OFFICIALS_FAILURE = 'EVENTS_GET_DRAW_OFFICIALS_FAILURE';
export const EVENTS_GET_DRAW_OFFICIALS_SUCCESS = 'EVENTS_GET_DRAW_OFFICIALS_SUCCESS';
export const EVENTS_ORDER_OF_PLAY_FETCH_SUCCESS = 'EVENTS_ORDER_OF_PLAY_FETCH_SUCCESS';
export const EVENTS_ORDER_OF_PLAY_SAVE_SUCCESS = 'EVENTS_ORDER_OF_PLAY_SAVE_SUCCESS';
export const EVENTS_ORDER_OF_PLAY_DELETE_SUCCESS = 'EVENTS_ORDER_OF_PLAY_DELETE_SUCCESS';
export const EVENTS_ADD_TEAM_STANDING_SUCCESS = 'EVENTS_ADD_TEAM_STANDING_SUCCESS';
export const EVENTS_EVENT_TEAM_STANDINGS_SUCCESS = 'EVENTS_EVENT_TEAM_STANDINGS_SUCCESS';
export const EVENTS_DELETE_TEAM_STANDING_SUCCESS = 'EVENTS_DELETE_TEAM_STANDING_SUCCESS';
export const EVENTS_EDIT_TEAM_STANDING_SUCCESS = 'EVENTS_EVENTS_EDIT_TEAM_STANDING_SUCCESS';

export const EVENTS_INCLUDE_IN_CONFERENCE_REQUEST = 'EVENTS:INCLUDE_IN_CONFERENCE_REQUEST';
export const EVENTS_INCLUDE_IN_CONFERENCE_SUCCESS = 'EVENTS:INCLUDE_IN_CONFERENCE_SUCCESS';
export const EVENTS_INCLUDE_IN_CONFERENCE_FAILURE = 'EVENTS:INCLUDE_IN_CONFERENCE_FAILURE';

export const EVENTS_OMIT_FROM_CONFERENCE_REQUEST = 'EVENTS:OMIT_FROM_CONFERENCE_REQUEST';
export const EVENTS_OMIT_FROM_CONFERENCE_SUCCESS = 'EVENTS:OMIT_FROM_CONFERENCE_SUCCESS';
export const EVENTS_OMIT_FROM_CONFERENCE_FAILURE = 'EVENTS:OMIT_FROM_CONFERENCE_FAILURE';

export const EVENTS_GET_ORGANIZER_RATINGS_SUCCESS = 'EVENTS:GET_ORGANIZER_RATINGS_SUCCESS';
export const EVENTS_SET_ORGANIZER_RATINGS_SUCCESS = 'EVENTS:SET_ORGANIZER_RATINGS_SUCCESS';

export const EVENTS_DRAW_CONTACTS_SUCCESS = 'EVENTS:DRAW_CONTACTS_SUCCESS';
export const EVENTS_PUBLISH_SUCCESS = 'EVENTS:PUBLISH_SUCCESS';
export const EVENTS_UNPUBLISH_SUCCESS = 'EVENTS:UNPUBLISH_SUCCESS';

export const EVENTS_SAFESPORT_FETCH_REQUEST = 'EVENTS:SAFESPORT_REQUEST';
export const EVENTS_SAFESPORT_FETCH_SUCCESS = 'EVENTS:SAFESPORT_SUCCESS';
export const EVENTS_SAFESPORT_FETCH_FAILURE = 'EVENTS:SAFESPORT_FAILURE';

export const EVENTS_GET_INVITATIONS_SUCCESS = 'EVENTS:GET_INVITATIONS_SUCCESS';
export const EVENTS_ACCEPT_INVITE_SUCCESS = 'EVENTS:ACCEPT_INVITE_SUCCESS';
export const EVENTS_DECLINE_INVITE_SUCCESS = 'EVENTS:DECLINE_INVITE_SUCCESS';

export const EVENTS_GET_EVENT_REGIONS_FETCH = 'EVENTS:GET_EVENT_REGIONS_FETCH';
export const EVENTS_GET_EVENT_REGIONS_SUCCESS = 'EVENTS:GET_EVENT_REGIONS_SUCCESS';

export const EVENTS_SET_PLAYER_WILDCARD = 'EVENTS_SET_PLAYER_WILDCARD';
export const EVENTS_SET_PLAYER_WILDCARD_SUCCESS = 'EVENTS_SET_PLAYER_WILDCARD_SUCCESS';

export const EVENTS_MOVE_PLAYER_TO_ROUND = 'EVENTS_MOVE_PLAYER_TO_ROUND';
export const EVENTS_MOVE_PLAYER_TO_ROUND_SUCCESS = 'EVENTS_MOVE_PLAYER_TO_ROUND_SUCCESS';
export const EVENTS_SET_DRAW_TAG = 'EVENTS_SET_DRAW_TAG';
export const EVENTS_SET_DRAW_TAG_SUCCESS = 'EVENTS_SET_DRAW_TAG_SUCCESS';
export const EVENTS_POST_NCSA_REG = 'EVENTS_POST_NCSA_REG';
export const EVENTS_POST_NCSA_REG_SUCCESS = 'EVENTS_POST_NCSA_REG_SUCCESS';
export const EVENTS_POST_NCSA_REG_FAILURE = 'EVENTS_POST_NCSA_REG_FAILURE';

export const EVENTS_CLEAR = 'EVENTS:CLEAR';
export const EVENTS_ADD_DIVISION = 'EVENTS:ADD_DIVISION';
export const EVENTS_META_FETCH_SUCCESS = 'EVENTS:META_FETCH_SUCCESS';
export const EVENTS_UPDATE_TEAM_SCORES_SUCCESS = 'EVENTS:UPDATE_TEAM_SCORES_SUCCESS';

export const EVENTS_CROP_BANNER_PHOTO_SUCCESS = 'EVENTS:CROP_BANNER_PHOTO_SUCCESS';
export const EVENTS_REMOVE_BANNER_PHOTO_SUCCESS = 'EVENTS:REMOVE_BANNER_PHOTO_SUCCESS';

export const EVENTS_SHOW_ADMIN_SPLASH = 'EVENTS:SHOW_ADMIN_SPLASH';
export const EVENTS_HIDE_ADMIN_SPLASH = 'EVENTS:HIDE_ADMIN_SPLASH';

export const EVENTS_UPDATE_MATCH_POSITION_REQUEST = 'EVENTS:UPDATE_MATCH_POSITION_REQUEST';
export const EVENTS_UPDATE_MATCH_POSITION_SUCCESS = 'EVENTS:UPDATE_MATCH_POSITION_SUCCESS';
export const EVENTS_ADD_MATCH_TO_ROUND = 'EVENTS:ADD_MATCH_TO_ROUND';
export const EVENTS_DELETE_MATCH = 'EVENTS:DELETE_MATCH';

export const EVENTS_ADD_DRAW = 'EVENTS:ADD_DRAW';
export const EVENTS_UPDATE_DRAW = 'EVENTS:UPDATE_DRAW';

export const EVENTS_INCLUDE_IN_ATT_STANDINGS_SUCCESS = 'EVENTS_INCLUDE_IN_ATT_STANDINGS_SUCCESS';
export const EVENTS_OMIT_FROM_ATT_STANDINGS_SUCCESS = 'EVENTS_OMIT_FROM_ATT_STANDINGS_SUCCESS';

export const TOGGLE_EVENT_LOADING = 'TOGGLE_EVENT_LOADING';
